import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../../assets/jss/util/messageUtil";
import { isLessThanDay } from "../../../../assets/jss/util/validateUtil";

const Themgiaykhamsuckhoe = React.memo(function Themgiaykhamsuckhoe(props) {
  const { laixe_id } = props;
  const [sogiayksk, setSogiayksk] = React.useState("");
  const [donvicap, setDonvicap] = React.useState("");
  const [ngaycap, setNgaycap] = React.useState(dayjs());
  const [ngayhethan, setNgayhethan] = React.useState(dayjs());
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  //const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const themgiaykham = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var ngaycapgp =
        ngaycap.$y +
        "-" +
        String(ngaycap.$M + 1).padStart(2, "0") +
        "-" +
        ngaycap.$D;
      var ngayhan =
        ngayhethan.$y +
        "-" +
        String(ngayhethan.$M + 1).padStart(2, "0") +
        "-" +
        ngayhethan.$D;
      var url = Config.backend + "/api/Donvi/themlaixegksk";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          laixe_id: laixe_id,
          sogiayksk: sogiayksk,
          donvicap: donvicap,
          ngaycap: ngaycapgp,
          ngayhethan: ngayhan,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra ngay cap GKSK va ngay het han GKSK
    if (isLessThanDay(ngayhethan, ngaycap)) {
      return Error.ER0049;
    }
    // Kiem tra cac truong bat buoc nhap
    if (sogiayksk.trim() === "") {
      return Error.ER0050;
    }
    if (donvicap.trim() === "") {
      return Error.ER0051;
    }
    return Success.SC0001;
  };
  // const disablebutton = () => {
  //   if (sogiayksk.trim().length > 0 && donvicap.trim().length > 0) {
  //     setDisableBT(false);
  //   } else {
  //     setDisableBT(true);
  //   }
  // };
  // React.useEffect(() => {
  //   disablebutton();
  // }, [sogiayksk, donvicap]);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số giấy khám sức khỏe"
                variant="outlined"
                size="small"
                value={sogiayksk}
                onChange={(event) => {
                  setSogiayksk(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Đơn vị cấp"
                variant="outlined"
                size="small"
                value={donvicap}
                onChange={(event) => {
                  setDonvicap(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp"
                  value={ngaycap}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaycap(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày hết hạn"
                  value={ngayhethan}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayhethan(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          //disabled={disableBT}
          onClick={themgiaykham}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Themgiaykhamsuckhoe.propTypes = {
  laixe_id: PropTypes.number,
};
export default Themgiaykhamsuckhoe;
